export const aiAgent = {
  head: {
    chip: "Reception IA",
    listingLabel: "Annuncio:",
  },
  globalNote: {
    title: "Impostazioni per tutto l'account",
    body: "Si applica a <b>TUTTE le tue strutture</b>. L'Agente IA risponde a chiunque scriva per la prima volta al tuo <b>numero WhatsApp collegato</b> che <b>non è ancora un cliente e non ha prenotazioni</b>: risponde alle sue domande e lo guida verso la prenotazione.",
  },
  perListingNote: {
    title: "Configurato per ogni annuncio",
    body: "L'emissione delle fatture utilizza l'<b>emittente di fatturazione</b> collegato a ciascun annuncio, quindi si attiva e si regola nelle impostazioni di ogni annuncio (non a livello globale). Apri un annuncio e vai su «Emissione fatture».",
  },
  noEmisor: {
    title: "Questo annuncio non ha un emittente di fatturazione",
    body: "L'emissione delle fatture non può essere attivata finché non colleghi un emittente a questo annuncio in <b>Il mio account → Fatturazione elettronica</b>. Ogni emittente è assegnato a un solo annuncio.",
  },
  master: {
    requiresEmisor: "Richiede un emittente di fatturazione",
    on: "Attivo",
    off: "Disattivo",
  },
  cartelQr: {
    title: "Cartello di check-in per la reception",
    hint: "Stampalo e lascialo sul bancone: l'ospite lo inquadra, scrive il numero della prenotazione e fa il check-in dal telefono. Utile quando l'OTA non manda tutti i dati.",
    steps: "L'ospite inquadra · scrive il numero della prenotazione · completa i suoi dati.",
    download: "Scarica il cartello (PDF)",
    downloading: "Preparazione…",
    downloadError: "Non è stato possibile preparare il cartello.",
    copy: "Copia link",
    copied: "Link copiato",
    language: "Lingua del cartello",
    alsoEnglish: "Aggiungere l'inglese sotto",

    copyManual: "Non è stato possibile copiare. Seleziona il link e copialo a mano.",
    popupBlocked: "Il browser ha bloccato la finestra. Copia il link e aprilo in un'altra scheda.",
    loadError: "Non è stato possibile caricare il cartello.",
    retry: "Riprova",  },
  checkinSchedule: {
    title: "Quando inizia il check-in?",
    hint: "Pianifica quando l'agente invia il link per il check-in all'ospite. Si applica a livello di annuncio.",
  },
  avisoCheckin: {
    title: "Avvisa via email al completamento del check-in",
    hint: "Quando il gruppo finisce la registrazione, inviamo il riepilogo della prenotazione — intestatario, accompagnatori e documenti — con la scheda firmata in allegato. Utile per la portineria o la reception.",
    enable: "Invia l'avviso",
    steps: "Inviato una sola volta, quando si registra l'ultima persona del gruppo.",
    placeholder: "portineria@tuastruttura.com",
    add: "Aggiungi email",
    remove: "Rimuovi",
    max: "Massimo {n} email.",
    save: "Salva",
    saving: "Salvataggio…",
    saved: "Avviso salvato",
    saveError: "Non è stato possibile salvare.",
    badEmail: "«{email}» non è un indirizzo valido.",
    needOne: "Aggiungi almeno un'email per attivare l'avviso.",
  },
  field: {
    optional: "(facoltativo)",
    yes: "Sì",
    no: "No",
  },
  variant: {
    nationality: "Nazionalità",
    writingStyle: "Stile di scrittura",
  },
  robot: {
    title: "Cosa sa l'agente",
  },
  pdf: {
    loaded: "Documento caricato · l'agente ne leggerà il contenuto",
    remove: "Rimuovi",
    replace: "Sostituisci PDF",
    dropTitle: "Carica un file PDF o Word con la guida della struttura",
    dropHint: "PDF o .docx · max 15 MB",
  },
  payments: {
    required: "Richiede il collegamento di una piattaforma di pagamento",
    connect: "Collega una piattaforma di pagamento →",
  },
  faq: {
    qPlaceholder: "Domanda · es. C'è parcheggio?",
    aPlaceholder: "Risposta · es. Sì, gratuito davanti alla porta.",
  },
  list: {
    remove: "Rimuovi",
    add: "Aggiungi",
  },
  footer: {
    saved: "Salvato",
    save: "Salva le modifiche",
  },
  wa: {
    online: "online",
    caption: "Anteprima · si aggiorna con le tue impostazioni",
    defaultName: "Reception IA",
  },
  errors: {
    pdfType: "Il file deve essere un PDF o un Word (.docx).",
    pdfSize: "Il file supera i 15 MB.",
    pdfNoText: "Non è stato possibile leggere alcun testo dal documento (è un PDF scansionato o vuoto?). Provane un altro o usa il testo libero.",
    pdfUpload: "Non è stato possibile caricare il PDF.",
    pdfRemove: "Non è stato possibile rimuovere il PDF.",
    loadConfig: "Non è stato possibile caricare le impostazioni.",
    saveConfig: "Impossibile salvare. Riprova.",
  },
  features: {
    general: {
      title: "Impostazioni generali",
      subtitle: "Definisci l'identità e lo stile dell'agente. Questa è un'impostazione dell'ACCOUNT: si applica a TUTTE le tue strutture.",
      sections: {
        identity: {
          label: "Identità dell'agente",
          hint: "Come si presenta e con quale stile risponde.",
        },
      },
      fields: {
        agentName: {
          label: "Nome dell'agente",
          placeholder: "es. Sofía, Reception Loft Ámbar…",
        },
        persona: {
          label: "Personalità",
          options: {
            amigable: "Amichevole e cordiale",
            profesional: "Professionale e intraprendente",
            eficiente: "Diretto ed efficiente",
            entusiasta: "Entusiasta e cordiale",
            sereno: "Calmo e rilassato",
          },
        },
        tone: {
          label: "Tono delle risposte",
          options: {
            cercano: "Informale",
            cordial: "Cordiale",
            formal: "Formale",
            profesional: "Professionale",
          },
        },
        responseLength: {
          label: "Lunghezza delle risposte",
          options: {
            brief: "Breve (1-2 frasi)",
            balanced: "Equilibrata",
            detailed: "Dettagliata",
          },
        },
        useEmojis: {
          label: "Usa emoji",
        },
        language: {
          label: "Lingua principale",
          options: {
            auto: "Automatica (in base all'ospite)",
            es: "Spagnolo",
            en: "Inglese",
            fr: "Francese",
            de: "Tedesco",
            pt: "Portoghese",
            it: "Italiano",
          },
        },
        spanishVariant: {
          label: "Stile di scrittura (spagnolo)",
        },
        signature: {
          label: "Firma di chiusura",
          placeholder: "es. — Il team di Loft Ámbar 🏡",
        },
      },
    },
    knowledge: {
      title: "Base di conoscenza",
      subtitle: "Tutto ciò che l'Agente IA deve sapere per assistere i tuoi ospiti con precisione.",
      enableLabel: "L'agente utilizza questa base di conoscenza",
      sections: {
        knowledge: {
          label: "Conoscenza della struttura",
          hint: "Scegli come fornire le informazioni che l'agente utilizzerà.",
        },
        behavior: {
          label: "Comportamento e limiti",
          hint: "Imposta le regole dell'agente e quando richiedere l'aiuto di un operatore.",
        },
      },
      fields: {
        kbMode: {
          label: "Come vuoi fornire le informazioni?",
          options: {
            form: "Moduli",
            text: "Testo libero",
            pdf: "Carica un documento",
          },
        },
        propertyType: {
          label: "Tipo di struttura",
          options: {
            apartment: "Appartamento",
            house: "Casa",
            villa: "Villa",
            loft: "Loft",
            room: "Stanza",
            cabin: "Baita",
            hotel: "Hotel",
            hostel: "Ostello",
          },
        },
        kbText: {
          label: "Informazioni sulla struttura",
          placeholder: "Scrivi o incolla qui TUTTO ciò che l'agente deve sapere: WiFi e password, parcheggio, elettrodomestici, riscaldamento/aria condizionata, regole della casa, consigli sulla zona…",
          hint: "L'agente utilizzerà questo testo così com'è per rispondere.",
        },
        kbPdf: {
          label: "Documento della struttura",
          hint: "Carica la guida della struttura come PDF o Word (.docx). L'agente ne leggerà il contenuto per rispondere.",
        },
        description: {
          label: "Informazioni generali",
          placeholder: "Come funzionano il riscaldamento e l'aria condizionata, gli elettrodomestici, la climatizzazione, le particolarità della struttura…",
          hint: "Contesto principale che l'agente utilizzerà in ogni risposta.",
        },
        wifiName: {
          label: "Nome WiFi",
          placeholder: "MyWifi_5G",
        },
        wifiPassword: {
          label: "Password WiFi",
        },
        parkingInfo: {
          label: "Parcheggio",
          placeholder: "Parcheggio gratuito davanti alla porta / Parcheggio a pagamento a 100 m / Nessun parcheggio…",
        },
        amenities: {
          label: "Servizi e dotazioni",
          placeholder: "Cucina attrezzata, lavatrice, asciugatrice, aria condizionata, ascensore, culla, asciugamani…",
        },
        houseRules: {
          label: "Regole della casa",
          placeholder: "Vietato fumare, niente feste, animali non ammessi, orario di silenzio 22:00–08:00…",
        },
        localRecommendations: {
          label: "Consigli sulla zona",
          placeholder: "Ristoranti, supermercati, trasporti, cosa visitare nelle vicinanze…",
        },
        faqs: {
          label: "Domande frequenti",
          hint: "Coppie di domanda e risposta. Puoi allegare immagini o video a ciascuna.",
        },
        links: {
          label: "Link e documenti",
          itemPlaceholder: "https://… (guida della casa, manuale, mappa)",
          hint: "Risorse esterne che l'agente può consultare.",
        },
        sendAmenityPhotos: {
          label: "Inviare le foto di dotazioni e comfort",
          hint: "Se l'ospite chiede di una dotazione che ha foto, l'agente risponde e gliele invia. Se non ne ha, risponde solo con il testo.",
        },
        customInstructions: {
          label: "Istruzioni personalizzate",
          placeholder: "Regole specifiche di tono o contenuto. Es. offri sempre il late checkout se chiedono informazioni sulla partenza.",
        },
        forbiddenTopics: {
          label: "Argomenti o azioni vietati",
          placeholder: "Es. non concedere sconti, non confermare modifiche di date senza approvazione, non condividere i dati di altri ospiti.",
        },
        escalationRules: {
          label: "Quando passare a un operatore",
          placeholder: "Es. in caso di guasto, reclamo grave o richiesta di rimborso, passa la conversazione all'host.",
        },
        fallbackMessage: {
          label: "Messaggio quando non conosce la risposta",
          placeholder: "Non ho questo dettaglio a portata di mano, ma lo comunicherò all'host e ti risponderemo subito 🙌",
        },
        humanContact: {
          label: "Contatto dell'host",
          placeholder: "+34 600 000 000",
        },
        supportHours: {
          label: "Orario di assistenza con operatore",
          placeholder: "Lun–Dom 09:00–21:00",
        },
      },
    },
    checkin: {
      title: "Check-in",
      enableLabel: "Gestisci il check-in automaticamente",
    },
    newBookings: {
      title: "Nuove prenotazioni e lead",
      subtitle: "L'agente si occupa dei nuovi lead (persone che scrivono per la prima volta e vogliono prenotare o hanno domande) e invia loro il link di Prenotazione Diretta per completare la prenotazione sul web. Questa è un'impostazione dell'ACCOUNT: si applica a tutte le tue strutture.",
      enableLabel: "Rispondi ai lead e alle richieste di prenotazione",
      sections: {
        businessIdentity: {
          label: "Identità dell'attività",
          hint: "Il nome con cui l'agente si presenta a chi non ha ancora prenotato.",
        },
        newLeads: {
          label: "Nuovi lead · primo contatto",
          hint: "Come si occupa di chi scrive per la prima volta, è interessato e non ha ancora prenotato.",
        },
        bookingLink: {
          label: "Link di prenotazione",
        },
      },
      fields: {
        businessName: {
          label: "Nome dell'attività",
          placeholder: "es. Ostello Elios, Appartamenti del Porto, Gruppo Ámbar…",
          hint: "Quando qualcuno senza prenotazione chiede chi sei, l'agente risponde «Sono l'assistente di [questo nome]». Se lo lasci vuoto, si presenta in modo generico, senza indicare a quale attività appartiene.",
        },
        leadWelcomeMessage: {
          label: "Messaggio di benvenuto per un nuovo lead",
          placeholder: "Ciao! 👋 Sono l'assistente della struttura. Stai cercando date per una vacanza o hai qualche domanda? Sono qui per aiutarti 😊",
          hint: "Saluto di primo contatto quando qualcuno scrive per la prima volta. Non viene ripetuto nei messaggi successivi.",
        },
        leadWelcomeVerbatim: {
          label: "Invia il saluto così com'è (senza adattarlo)",
          hint: "Attivo: l'agente usa il tuo messaggio parola per parola al primo contatto. Disattivo: lo adatta al tono della conversazione.",
        },
        answerKbForLeads: {
          label: "Rispondi alle domande anche prima che abbiano prenotato",
          hint: "L'agente risponde alle loro domande generali con la base di conoscenza —anche se non sono ancora ospiti— e può anche inviare loro il link di prenotazione.",
        },
        proactiveOffer: {
          label: "Proponi la prenotazione in modo proattivo",
          hint: "Anche se il lead chiede di altro, l'agente lo incoraggia a prenotare e invia il link quando è opportuno, senza insistere.",
        },
        offerMessage: {
          label: "Messaggio per proporre la prenotazione",
          placeholder: "Certo! Puoi prenotare direttamente qui 👇 Ti invio il link per scegliere le date.",
          hint: "Il tono che l'agente usa quando propone la prenotazione. L'agente aggiunge il link automaticamente.",
        },
      },
    },
    earlyAccess: {
      title: "Gestione dell'orario di arrivo",
      subtitle: "L'agente gestisce le richieste di check-in anticipato: registra l'orario di arrivo richiesto dall'ospite e lo tratta secondo le tue regole.",
      enableLabel: "Gestisci gli orari di arrivo",
      sections: {
        request: {
          label: "Gestione delle richieste",
          hint: "Come risponde l'agente in base all'orario richiesto. Se le disattivi, la richiesta resta in sospeso e potrai scegliere tu (Approva / Approva un altro orario / Dai priorità / Rifiuta).",
        },
      },
      fields: {
        autoTentativeEarly: {
          label: "Rispondi «soggetto a disponibilità» se è prima del check-in",
          hint: "L'agente dice all'ospite che ci proverai; resta in attesa della tua conferma.",
        },
        autoApproveLate: {
          label: "Approva automaticamente se è dopo il check-in",
          hint: "Un arrivo entro l'orario normale viene confermato automaticamente.",
        },
      },
    },
    lateCheckout: {
      title: "Late checkout",
      subtitle: "L'agente gestisce le richieste di late checkout: verifica l'orario, comunica il prezzo e registra la richiesta.",
      enableLabel: "Gestisci il late checkout",
      sections: {
        availability: {
          label: "Disponibilità e orari",
        },
        extraPrice: {
          label: "Prezzo delle ore extra",
          hint: "Viene addebitata solo la parte successiva alle ore di cortesia.",
        },
        messages: {
          label: "Messaggi",
        },
      },
      fields: {
        standardCheckout: {
          label: "Orario di checkout standard",
        },
        courtesyHours: {
          label: "Ore di cortesia (gratuite)",
          unit: "h",
          hint: "Ore dopo il checkout standard che non vengono MAI addebitate.",
        },
        latestTime: {
          label: "Orario massimo di checkout",
          hint: "Limite assoluto. Oltre il periodo di cortesia, le ore extra vengono addebitate.",
        },
        subjectToAvailability: {
          label: "Soggetto a disponibilità",
          hint: "Le ore extra vengono offerte solo se quel giorno non arriva un'altra prenotazione.",
        },
        autoConfirm: {
          label: "Conferma automaticamente se l'ospite accetta",
          hint: "Si applica solo alle ore gratuite.",
        },
        pricingModel: {
          label: "Modello di prezzo",
          options: {
            fixed: "Prezzo fisso",
            perHour: "Per ora extra",
          },
        },
        price: {
          label: "Importo",
          hint: "Prezzo fisso o tariffa per ora extra oltre il periodo di cortesia.",
        },
        freeIfAvailable: {
          label: "Gratuito se non ci sono arrivi lo stesso giorno",
          hint: "Se quel giorno è libero, le ore extra non vengono addebitate.",
        },
        paymentMethods: {
          label: "Metodi di pagamento per le ore extra",
          options: {
            online: "Pagamento online (Stripe) — l'agente invia un link",
            cash: "Contanti al checkout",
          },
          hint: "Puoi offrire uno o entrambi. L'agente lo comunicherà all'ospite.",
        },
        offerMessage: {
          label: "Messaggio di offerta",
          placeholder: "Hai bisogno di più tempo? Possiamo offrire il checkout fino alle 13:00.",
        },
        confirmationMessage: {
          label: "Messaggio di conferma",
          placeholder: "Fatto! Il tuo late checkout è confermato. Goditi queste ore extra 🙌",
        },
      },
    },
    invoicing: {
      title: "Emissione fatture",
      subtitle: "L'agente invia all'ospite un link per completare i propri dati fiscali e scaricare la fattura elettronica, utilizzando l'emittente di fatturazione collegato a questo annuncio.",
      enableLabel: "Gestisci le richieste di fattura",
      sections: {
        whenSend: {
          label: "Quando viene inviato il link della fattura?",
          hint: "Scegli come far arrivare il link all'ospite. Le opzioni per la modalità scelta compaiono qui sotto.",
        },
        requirements: {
          label: "Requisiti per l'invio immediato",
          hint: "L'agente consegna il link solo agli ospiti che hanno già completato il check-in e pagato per intero la prenotazione; una volta inseriti i dati, la fattura viene emessa e scaricata all'istante. Per le prenotazioni OTA (Booking/Airbnb) la fattura può essere ricevuta solo quando il servizio è iniziato (il soggiorno è cominciato) e il pagamento è completo.",
        },
        manualReview: {
          label: "Revisione manuale",
          hint: "Viene registrata solo la richiesta dell'ospite, che resta in sospeso in «Fatture in attesa di invio» perché tu la emetta manualmente. Nessuna fattura viene generata automaticamente e non importa quando la richiedono né se la prenotazione è pagata (la controlli tu).",
        },
        fiscalData: {
          label: "Dati fiscali dell'emittente",
          hint: "I dati fiscali (ragione sociale, codice fiscale, serie, VAT, Verifactu) NON si configurano qui: vengono presi dall'emittente di fatturazione collegato a questo annuncio in Il mio account → Fatturazione elettronica.",
        },
        sendToGuest: {
          label: "Invio all'ospite",
        },
      },
      modes: {
        after_checkout: {
          label: "Solo su richiesta",
          desc: "Il concierge IA risponde quando l'ospite chiede la fattura.",
        },
        always_after_checkout: {
          label: "Sempre, al termine del soggiorno",
          desc: "A tutti coloro che hanno completato il check-in, che lo chiedano o meno. Consigliato.",
        },
      },
      cards: {
        on_request: {
          label: "Non appena lo chiedono",
          desc: "Ricevono subito il link, se soddisfano i requisiti.",
        },
        after_checkout: {
          label: "Al termine del soggiorno",
          desc: "La richiesta viene salvata e il link arriva loro dopo il checkout.",
        },
        manual: {
          label: "Registrala e basta",
          desc: "Resta in sospeso e la emetti manualmente.",
        },
      },
      fields: {
        autoIssueIfNotSubmitted: {
          label: "Emetti la fattura anche se non compilano il modulo",
          hint: "Viene emessa utilizzando i dati del check-in e il PDF viene inviato via email e WhatsApp. Una fattura emessa non può essere modificata.",
        },
        autoIssueAfterHours: {
          label: "Quanto attendere prima di emetterla",
          options: {
            h24: "24 ore dopo l'invio del link",
            h48: "48 ore dopo l'invio del link",
            h72: "72 ore dopo l'invio del link",
          },
        },
        manualSendLink: {
          label: "Invia all'ospite il link per completare i propri dati fiscali",
          hint: "Se lo attivi, l'agente invia il link affinché l'ospite possa fornire i propri dati in anticipo. La fattura viene comunque emessa manualmente.",
        },
        sendToGuest: {
          label: "Invia il link all'ospite tramite",
          options: {
            email: "Email",
            whatsapp: "WhatsApp",
          },
        },
      },
    },
    extendStay: {
      title: "Prolunga il soggiorno",
      subtitle: "L'agente gestisce le richieste di aggiungere notti: verifica la disponibilità, comunica il prezzo e registra la richiesta.",
      enableLabel: "Consenti le richieste di prolungamento del soggiorno",
      sections: {
        availability: {
          label: "Disponibilità",
          hint: "Il numero massimo di notti è determinato automaticamente dalla prenotazione successiva sul calendario.",
        },
        price: {
          label: "Prezzo",
        },
        messages: {
          label: "Messaggi",
        },
      },
      fields: {
        autoConfirm: {
          label: "Prolunga la prenotazione automaticamente alla conferma",
          hint: "Se lo disattivi, resta una richiesta da approvare.",
        },
        useListingRate: {
          label: "Usa la tariffa per notte dell'annuncio",
          hint: "Calcola la tariffa a partire dal prezzo della prenotazione.",
        },
        pricePerNight: {
          label: "Prezzo per notte aggiuntiva",
          hint: "Solo se non usi la tariffa dell'annuncio.",
        },
        paymentMethods: {
          label: "Metodi di pagamento per le notti extra",
          options: {
            online: "Pagamento online (Stripe) — l'agente invia un link",
            cash: "Contanti",
          },
        },
        offerMessage: {
          label: "Messaggio di offerta",
          placeholder: "Vuoi fermarti più a lungo? Posso aggiungere notti alla tua prenotazione, soggetto a disponibilità.",
        },
        confirmationMessage: {
          label: "Messaggio di conferma",
          placeholder: "Perfetto! Ho registrato le notti extra. Confermeremo non appena il pagamento sarà completo 🙌",
        },
      },
    },
  },
  preview: {
    common: {
      noCost: "senza costi",
      subjectToAvailability: " Soggetto a disponibilità.",
    },
    default: "Ciao! Come posso aiutarti? 😊",
    knowledge: {
      guestWifi: "Qual è la password del WiFi? 📶",
      wifiAnswer: "Certo! La rete WiFi è *{name}* e la password è *{pass}*. Buona navigazione! 😊",
      wifiNameFallback: "della struttura",
      wifiPassFallback: "••••••",
      genericAnswer: "Certo! Ti invio subito tutte le informazioni di cui hai bisogno sulla struttura 😊",
    },
    checkin: {
      propFallback: "tu alojamiento",
      welcome: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{prop}*.\nEstoy aquí para ayudarte con el proceso de check-in.\n\nPresiona 'Ok' para continuar con el check-in.\n\n🇬🇧 *Hi* 👋 I'm 🤖 the virtual assistant of *{prop}*.\nI'll help you with the check-in process.\n\nPress 'Ok' to continue with the check-in.",
      ok: "Ok",
      chooseLang: "Elige tu idioma · Choose your language",
      langEs: "Español",
      langEn: "English",
      linkMsg: "*Gracias* 👋 Este es tu link para hacer el Check-In. 😎\n\n{link}",
    },
    newBookings: {
      offerDefault: "Certo! 😊 Puoi prenotare direttamente qui. Ti invio il link per scegliere le date:",
      whoAsk: "Con chi sto parlando?",
      whoAnswer: "Ciao! Sono l'assistente di {biz} 😊 Come posso aiutarti?",
      guestGreeting: "Ciao! Avete disponibilità per questo fine settimana? 😊",
      howBook: "Perfetto, come prenoto?",
      linkLine: "{offer}\n\n🔗 Prenota qui: {link}",
    },
    earlyAccess: {
      guestAsk: "Potrei fare il check-in prima? Arrivo verso mezzogiorno 🙏",
      tentativeReply: "Abbiamo annotato il tuo arrivo anticipato alle 12:00. Faremo del nostro meglio per averlo pronto, ma dipende dal checkout dell'ospite precedente e dalle pulizie. Ti avviseremo non appena sarà disponibile 🙏",
      confirmedReply: "Abbiamo registrato il tuo arrivo anticipato alle 12:00. Confermeremo a breve 🙏",
    },
    lateCheckout: {
      courtesyPart: "Hai {hours}h di cortesia gratuita dopo le {time}. ",
      costPart: "Fare il checkout entro le {time} costa {price}{perHour}.",
      perHourSuffix: " per ora extra",
      payBoth: " Puoi pagare online o in contanti al checkout.",
      payCash: " Il pagamento è in contanti al checkout.",
      guestAsk: "Posso fare il checkout più tardi domani? 😅",
      guestConfirm: "OK, confermo 👍",
      cashExtra: " (o in contanti al checkout)",
      confirmPayDefault: "Fatto! Per confermare, completa il pagamento{extra}:",
      payLabel: "Paga {price}",
      confirmCashDefault: "Fatto! Il tuo late checkout è confermato. Il pagamento di {price} è in contanti al checkout. 😊",
    },
    invoicing: {
      guestAsk: "Puoi inviarmi la fattura? 🧾",
      linkMsg: "Ciao! 👋\n\nEcco il link per generare e scaricare la tua fattura elettronica:\n{link}\n\nPuoi tornare a questo link ogni volta che hai bisogno di accedervi.",
      thanks: "Grazie per il tuo soggiorno! 🙌 Se ti serve la fattura, ecco il link 👇",
      autoIssueNote: "_({hours}h dopo, se non hanno completato i propri dati)_\n\nAbbiamo emesso la tua fattura utilizzando i dati del check-in e te l'abbiamo inviata via email. 📩",
      manualLinkMsg: "Ciao! 👋\n\nEcco il link per completare i tuoi dati fiscali:\n{link}\n\nEsamineremo la tua richiesta ed emetteremo la fattura manualmente. 😊",
      manualRegistered: "Ciao! 👋 Ho registrato la tua richiesta di fattura. La esamineremo e la emetteremo manualmente il prima possibile. Grazie! 😊",
    },
    extendStay: {
      guestAsk: "Posso fermarmi una notte in più? 🌙",
      guestConfirm: "Sì, una notte in più 👍",
      rateListing: "alla tariffa della tua prenotazione",
      ratePerNight: "a {price}/notte",
      nightSingular: "notte",
      nightPlural: "notti",
      offerDefault: "Certo! Posso aggiungere fino a {max} {nights} {rate}.{avail}",
      cashExtra: " (o in contanti)",
      confirmPayDefault: "Perfetto! Per confermare la notte extra, completa il pagamento{extra}:",
      payLabel: "Paga la notte extra",
      confirmCashDefault: "Perfetto! Ho registrato la notte extra. Il pagamento è in contanti e l'host confermerà il prolungamento. 😊",
    },
    general: {
      guestAsk: "Ciao! Con chi sto parlando?",
      whoWithName: "Sono {name}, il tuo",
      whoNoName: "Sono il tuo",
      answer: "Ciao! {who} assistente alla reception. Come posso aiutarti?{emo}",
    },
  },
  nationalities: {
    auto: "Automatica (in base all'ospite)",
    latam: "America Latina (neutro)",
    countries: {
      ES: "Spagna",
      MX: "Messico",
      CO: "Colombia",
      AR: "Argentina",
      CL: "Cile",
      PE: "Perù",
      VE: "Venezuela",
      EC: "Ecuador",
      UY: "Uruguay",
      PY: "Paraguay",
      BO: "Bolivia",
      CR: "Costa Rica",
      PA: "Panama",
      GT: "Guatemala",
      DO: "Rep. Dominicana",
      PR: "Porto Rico",
      CU: "Cuba",
      FR: "Francia",
      PT: "Portogallo",
      BR: "Brasile",
      US: "Stati Uniti",
      IT: "Italia",
      BE: "Belgio",
      MA: "Marocco",
      NL: "Paesi Bassi",
      CH: "Svizzera",
    },
    styles: {
      latamNeutral: "Latinoamericano neutro",
      esES: "Standard — informale (tú) · «vale», «genial»",
      esMX: "Standard — «con gusto», «estacionamiento»",
      esCO: "Generale — formale (usted) · «con gusto»",
      esCOpaisa: "Paisa (Medellín) — «pues», «hágale»",
      esCOcosta: "Costiero (caraibico) — «¡ajá!», «quihubo»",
      esCOrolo: "Rolo (Bogotá) — formale (usted) · «a la orden»",
      esCOvalle: "Valluno (Cali) — voseo · «vea pues»",
      esCOsantander: "Santander — diretto · «de una»",
      esAR: "Voseo — «dale», «buenísimo»",
      esCL: "Caloroso — «estacionamiento»",
      esPE: "Formale (usted) — andino neutro",
      esVE: "Informale (tú) — «chévere»",
      esEC: "Formale (usted) — andino neutro",
      esUY: "Voseo — «ta», «bo»",
      esPY: "Voseo — caloroso",
      esBO: "Formale (usted) — andino",
      esCR: "Voseo — «pura vida»",
      esPA: "Informale (tú) — caraibico",
      esGT: "Formale (usted) — caloroso",
      esDO: "Informale (tú) — caraibico",
      esPR: "Informale (tú) — caraibico",
      esCU: "Informale (tú) — caraibico",
      frFR: "Francese (Francia)",
      ptPT: "Portoghese (Portogallo)",
      ptBR: "Portoghese (Brasile)",
      enUS: "Inglese americano",
      itIT: "Italiano (Italia)",
      frBE: "Francese (Belgio)",
      nlBE: "Olandese / Fiammingo (Belgio)",
      arMA: "Arabo (Marocco)",
      frMA: "Francese (Marocco)",
      nlNL: "Olandese",
      deCH: "Tedesco svizzero",
      frCH: "Francese svizzero",
      itCH: "Italiano svizzero",
    },
  },
};
